// PWA Service Worker constants

/** How often to check for SW updates (ms). */
export const SW_UPDATE_CHECK_INTERVAL = 60 * 60 * 1000; // 1 hour

/**
 * Workbox BackgroundSync queue names. Centralised here so the SW, the
 * tests, and the docs agree. Must match `BgSyncTag` in `@bbpos/types`.
 */
export const SW_BG_SYNC_PUSH_QUEUE = 'bbpos-sync-push';
export const SW_BG_SYNC_RETRY_QUEUE = 'bbpos-sync-retry';

/** How long a BackgroundSync request is kept before giving up (minutes). */
export const SW_BG_SYNC_MAX_RETENTION_MINUTES = 24 * 60; // 24 h

/** Workbox cache names used in vite.config.ts runtimeCaching. */
export const CACHE_NAMES = {
  auth: 'api-auth',
  categories: 'api-categories',
  shifts: 'api-shifts',
  locations: 'api-locations',
  notifications: 'api-notifications',
  staticAssets: 'static-assets',
} as const;

/** Runtime caching strategy descriptions (for Settings / diagnostics). */
export const CACHE_STRATEGIES = [
  { name: 'Products', strategy: 'NetworkOnly', ttl: 'n/a', description: 'Always live; the offline catalogue comes from IndexedDB, not the HTTP cache' },
  { name: 'Categories', strategy: 'StaleWhileRevalidate', ttl: '24 hours', description: 'Cached first, refreshed in background' },
  { name: 'User Profile', strategy: 'NetworkFirst', ttl: '24 hours', description: 'Auth data for session' },
  { name: 'Shifts', strategy: 'NetworkFirst', ttl: '1 hour', description: 'Active shift data' },
  { name: 'Locations', strategy: 'StaleWhileRevalidate', ttl: '24 hours', description: 'Location list for multi-store' },
  { name: 'Notifications', strategy: 'NetworkFirst', ttl: '30 minutes', description: 'Notification inbox' },
  { name: 'Static Assets', strategy: 'CacheFirst', ttl: '30 days', description: 'Images, fonts, icons' },
  { name: 'Sync Push (BG)', strategy: 'BackgroundSync', ttl: '24 hours', description: 'Offline POST replays after reconnect' },
] as const;
